import * as React from 'react';
import View from './view';
import {Route} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {useEffect} from 'react';
import {SocialSupportListData} from '../../shared/components/socialSupportList/model';
import {ExpenseLiability} from '../../shared/models/socialSupport/expenseLiability';
import {expenseLiabilitiesSelector} from '../../redux/selectors/socialSupport/expenseLiabilities';
import {getExpenseLiabilities} from '../../redux/actions/socialSupport/expenseLiabilities';

const expenseLiabilitiesToSocialSupportListData = (data: ExpenseLiability[]): SocialSupportListData[] => {
  return data.map((program) => ({
    title: program.grbsName,
    children: program.credentials.map((credentiall) => ({
      title: credentiall.credentialName,
      children: credentiall.fkrs.map((fkrs) => ({
        title: fkrs.fkrName,
        table: {
          data: fkrs.rows,
          columns: [
            {field: 'targetItem', title: 'Целевая статья', size: 3},
            {field: 'expenseType', title: 'Код вида расхода'},
            {field: 'additionalClassificationCode', title: 'Код доп. классификации'},
            {field: 'federalAct', title: 'Федеральный НПА'},
            {field: 'federalActDetails', title: 'Реквизиты федерального НПА'},
            {field: 'regionalAct', title: 'Областной НПА'},
            {field: 'regionalActDetails', title: 'Реквизиты областного НПА'},
            {field: 'year', title: 'Год'},
            {field: 'periodType', title: 'Тип периода'},
            {field: 'actualAmount', title: 'Факт'},
            {field: 'sourceOfFinancing', title: 'Источник финансирования'},
            {field: 'estimationMethod', title: 'Методика оценки'},
            {field: 'estimatedAmount', title: 'Оценка'},
          ],
        },
      })),
    })),
  }));
};

export const ExpenseLiabilitiesScreen: React.FC<{route: Route<string>}> = ({route}) => {
  const dispatch = useAppDispatch();
  const expenseLiabilities = useSelector(expenseLiabilitiesSelector());
  useEffect(() => {
    if (!expenseLiabilities) {
      dispatch(getExpenseLiabilities());
    }
  }, [expenseLiabilities]);
  const socialSupportData = expenseLiabilitiesToSocialSupportListData(expenseLiabilities ?? []);
  return <View route={route} socialSupportData={socialSupportData} />;
};
